// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export let BaseSettingsUtils = null; // NOSONAR - mutable singleton reference initialized at runtime
export function BaseGeneralSettingsUtilsInstanceCreator(settingsUtils) {
    BaseSettingsUtils = settingsUtils;
}
